import React from "react";
import "./style.css";

const Tooltip = ({ text, iconClassName }) => {
  return (
    <div className="tooltip">
      <span className="icon">
        <i className={`fas ${iconClassName}`}></i>
      </span>
      <span className="tooltip-text">{text}</span>
    </div>
  );
};

export default Tooltip;
